import React, { useState, useEffect } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import axios from "axios";

const MovieForm = () => {
  let { id } = useParams();
  let history = useHistory();
  const [input, setInput] = useState({
    title: "",
    description: "",
    year: 0,
    duration: 0,
    genre: "",
    rating: 0,
    review: "",
    image_url: "",
  });
  const [fetch, setFetch] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        const result = await axios.get(
          `https://backendexample.sanbersy.com/api/data-movie/${id}`
        );
        const {
          title,
          description,
          year,
          duration,
          genre,
          rating,
          review,
          image_url,
        } = result.data;
        setInput({
          title,
          description,
          year,
          duration,
          genre,
          rating,
          review,
          image_url,
        });
      }
    };
    if (fetch) {
      fetchData();
      setFetch(false);
    }
  }, [fetch, id]);

  const handleChange = (event) => {
    let value = event.target.value;
    let typeOfInput = event.target.name;
    setInput({
      ...input,
      [typeOfInput]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const {
      title,
      description,
      year,
      duration,
      genre,
      rating,
      review,
      image_url,
    } = input;

    if (id) {
      // berarti update data yang sudah ada (dapat dari currentId)
      axios
        .put(`https://backendexample.sanbersy.com/api/data-movie/${id}`, {
          title,
          description,
          year,
          duration,
          genre,
          rating,
          review,
          image_url,
        })
        .then(() => {
          history.push("/movie");
        });
    } else {
      // berarti create data baru

      axios
        .post(`https://backendexample.sanbersy.com/api/data-movie`, {
          title,
          description,
          year,
          duration,
          genre,
          rating,
          review,
          image_url,
        })
        .then(() => {
          history.push("/movie");
        });
    }

    setInput({
      title: "",
      description: "",
      year: 0,
      duration: 0,
      genre: "",
      rating: 0,
      review: "",
      image_url: "",
    });
  };

  return (
    <>
      <div style={{ marginTop: "40px" }}>
        <h1 style={{ textAlign: "center" }}>Form Tambah data Movie</h1>
        <form style={{marginBottom:"150px"}} onSubmit={handleSubmit}>
          <br/>
          <table style={{margin:"auto"}}>
            <tr>
            <th><label style={{ float: "left" }}>Movie Title:</label></th>
            <th><input
              type="text"
              required
              value={input.title}
              placeholder="Masukan Nama Anda"
              name="title"
              onChange={handleChange}
            /></th>
            </tr>
            <tr>
            <th><label style={{ float: "left" }}>Genre:</label></th>
            <th><input
              type="select"
              required
              placeholder="0"
              size="40"
              name="genre"
              value={input.genre}
              onChange={handleChange}
              />
               </th>
               </tr>
            <tr>
            <th><label style={{ float: "left" }}>Rating:</label></th>
            <th><input
              type="range"
              min="0"
              required
              max="10"
              placeholder="0"
              size="40"
              name="rating"
              value={input.rating}
              onChange={handleChange}
            />
            </th>
            </tr>
            <tr>
            <th>
            <label style={{ float: "left" }}>Duration(Minutes):</label>
            </th>
            <th>
            <input
              type="number"
              min="0"
              required
              placeholder="0"
              size="40"
              name="duration"
              value={input.duration}
              onChange={handleChange}
            />
            </th>
            </tr>
            <tr>
            <th>
            <label style={{ float: "left" }}>Release Year:</label>
            </th>
            <th>
            <input
              type="number"
              min="0"
              required
              placeholder="0"
              size="40"
              name="year"
              value={input.year}
              onChange={handleChange}
            />
            </th>
            </tr>
            <tr>
            <th>
            <label style={{ float: "left" }}>Description:</label>
            </th>
            <th>
            <input
              type="text"
              required
              // placeholder="0"
              size="40"
              name="description"
              value={input.description}
              onChange={handleChange}
            />
            </th>
            </tr>
            <tr>
            <th>
            <label style={{ float: "left" }}>Image Url:</label>
            </th>
            <th>
            <input
              type="text"
              required
              // placeholder="0"
              size="40"
              name="image_url"
              value={input.image_url}
              onChange={handleChange}
            />
            </th>
            </tr>
            <button style={{ borderRadius: "7px", marginRight: "200px" }}>
              submit
            </button>
          </table>
        </form>
      </div>
    </>
  );
};
export default MovieForm;
